export const storeToLocalStorage = (data, key) => {
  localStorage.setItem(key, data);
};

export const getFromLocalStorage = (key) => {
  const data = localStorage.getItem(key);
  return data;
};

export const clearLocalStorage = (key) => {
  localStorage.removeItem(key);
};



// WEBPACK FOOTER //
// ./src/utils/storeLocalStorage.js